/**
 * Plansza i płytki polskich Scrabble.
 *
 * Rozkład premii i liter jest odwzorowaniem oficjalnej wersji — nie miejsce
 * na wariacje, bo to jedyna część gry, którą wszyscy znają na pamięć
 * i natychmiast zauważą, gdy się nie zgadza.
 */
export const BOARD_SIZE = 15;
/** Środek planszy — pierwsze słowo musi go zakryć. */
export const CENTER = 7;
export const RACK_SIZE = 7;
/**
 * Premie: `P` = premia za literę, `S` = za słowo.
 *
 * Zapisane jako mapa ćwiartki, a nie 225 pól — plansza jest symetryczna
 * względem obu osi, więc rozpisywanie jej w całości to trzykrotnie więcej
 * miejsca na pomyłkę.
 */
const QUADRANT = [
    [0, 0, "S3"], [0, 3, "P2"], [0, 7, "S3"],
    [1, 1, "S2"], [1, 5, "P3"],
    [2, 2, "S2"], [2, 6, "P2"],
    [3, 0, "P2"], [3, 3, "S2"], [3, 7, "P2"],
    [4, 4, "S2"],
    [5, 1, "P3"], [5, 5, "P3"],
    [6, 2, "P2"], [6, 6, "P2"],
    [7, 0, "S3"], [7, 3, "P2"],
];
function buildBoard() {
    const board = Array.from({ length: BOARD_SIZE }, () => Array.from({ length: BOARD_SIZE }, () => ""));
    for (const [row, column, premium] of QUADRANT) {
        // Odbicie w obu osiach daje pełną planszę z jednej ćwiartki.
        for (const r of [row, BOARD_SIZE - 1 - row]) {
            for (const c of [column, BOARD_SIZE - 1 - column]) {
                board[r][c] = premium;
            }
        }
    }
    // Środek jest polem startowym i liczy się jak premia podwójna za słowo.
    board[CENTER][CENTER] = "S2";
    return board;
}
export const PREMIUMS = buildBoard();
export function premiumAt(row, column) {
    return PREMIUMS[row]?.[column] ?? "";
}
/**
 * Wartości punktowe liter w polskiej wersji.
 *
 * Blank (pusta płytka) ma wartość 0 i zapisywany jest jako `?`.
 */
export const LETTER_POINTS = {
    a: 1, e: 1, i: 1, n: 1, o: 1, r: 1, s: 1, w: 1, z: 1,
    c: 2, d: 2, k: 2, l: 2, m: 2, p: 2, t: 2, y: 2,
    b: 3, g: 3, h: 3, j: 3, ł: 3, u: 3,
    ą: 5, ę: 5, f: 5, ó: 5, ś: 5, ż: 5,
    ć: 6,
    ń: 7,
    "ź": 9,
    "?": 0,
};
/** Ile płytek każdej litery jest w woreczku. Razem 100. */
export const TILE_DISTRIBUTION = {
    a: 9, i: 8, e: 7, o: 6, n: 5, z: 5, r: 4, s: 4, w: 4,
    c: 3, d: 3, k: 3, l: 3, m: 3, p: 3, t: 3, y: 4,
    b: 2, g: 2, h: 2, j: 2, ł: 2, u: 2,
    ą: 1, ę: 1, f: 1, ó: 1, ś: 1, ż: 1, ć: 1, ń: 1, "ź": 1,
    "?": 2,
};
export function pointsFor(letter) {
    return LETTER_POINTS[letter.toLowerCase()] ?? 0;
}
/** Pełny woreczek — 100 płytek, jeszcze nieprzetasowanych. */
export function fullBag() {
    const bag = [];
    for (const [letter, count] of Object.entries(TILE_DISTRIBUTION)) {
        for (let i = 0; i < count; i++)
            bag.push(letter);
    }
    return bag;
}
//# sourceMappingURL=board.js.map